export default {
    nav: {
        home: 'Home',
        services: 'Services | Packages',
        about: 'About Us',
        achievements: 'Portfolio',
        gallery: 'Gallery',
        contact: 'Contact',
        typography: 'Typography'
    },
    hero: {        
        
        title: 'IT support Service Provider in Germany and Europe, Customized IT Services & Best Solutions',
subtitle: 'We help you transform and optimize your business processes and workflows with innovative technologies. We deliver the best IT solutions including IT Service Management (ITSM), IT Infrastructure, and 24/7 IT Support.',
        sliderText: 'We believe teamwork, responsibility, and mutual respect are essential to delivering high-quality services and solutions.',
        cta: 'Get Started'
    },
    services: {
        title: 'Our most requested services - and that\'s just the beginning.',
        subtitle: 'Comprehensive IT Services from Your Experienced IT Service Provider',
        description: 'As an experienced IT Service Provider in Heidelberg, Heidelbell delivers the best IT solutions and services. Empowering your business with cutting-edge technology solutions and expert support. Our proven 3Es approach ensures successful project delivery. We offer on-demand dispatch and IT Infrastructure support all over Germany and neighbouring European countries leveraging our pool of competent Smart-Hands and engineers.',
        hero: {
            titlePart1: 'We not just offer IT support service,',
            titlePart2: 'we believe in the power of technology to transform businesses.',
            subtitle: 'From smart hands to experts, we are here get your job right done.'
        },
        landingCTA: {
            title: 'Ready to Transform Your Business?',
            description: 'Let\'s discuss how our IT solutions can drive your success with our proven 3Es approach.',
            buttonConsultation: 'Get Free Consultation',
            buttonPortfolio: 'View Our Portfolio'
        },
        overview: {
            label: 'Our Expertise',
            title: 'Comprehensive IT Services',
            description: 'We offer customized IT solutions for businesses of all sizes. Our experts support you in digital transformation.'
        },
        servicesList: {
            
            cloud: {
                title: 'Cloud Solutions',
                description: 'Modern cloud infrastructure and services for scalable and secure business applications.',
                features: [
                    'Cloud Migration & Strategy',
                    'Infrastructure as a Service',
                    'Cloud Security & Compliance',
                    '24/7 Cloud Monitoring'
                ],
                benefits: [
                    'Cost savings through optimized resource utilization',
                    'Higher flexibility and scalability',
                    'Improved security and compliance',
                    'Faster time-to-market for new applications'
                ]
            },
            
            resourceTeams: {
                title: 'Resource or Teams as Services',
                description: 'Access skilled IT professionals and dedicated teams on-demand to scale your projects and operations.',
                features: [
                    'Dedicated Team Services',
                    'Staff Augmentation',
                    'Expert Resource Allocation',
                    'Flexible Team Scaling'
                ],
                benefits: [
                    'Access to specialized IT expertise when needed',
                    'Scalable team resources for project demands',
                    'Cost-effective solution for temporary or ongoing needs',
                    'Reduced hiring and training overhead'
                ]
            },
            itSupport: {
                title: 'IT Support',
                description: 'Experts for technical support and maintenance of your IT infrastructure.',
                features: [
                    '24/7 Technical Support',
                    'System Maintenance',
                    'Hardware & Software Support',
                    'Remote Assistance'
                ],
                benefits: [
                    'Minimized downtime',
                    'Fast problem resolution',
                    'Proactive system maintenance',
                    'Cost-effective IT care'
                ]
            },
            optimization: {
                title: 'Process Optimization',
                description: 'Elevate your operations with our systematic approach to process optimization. We identify bottlenecks, implement RPA automation, and leverage data-driven insights to deliver measurable improvements in efficiency and cost savings.',
                features: [
                    'Process Analysis & Mapping',
                    'Efficiency Improvement',
                    'Workflow Automation',
                    'Performance Monitoring'
                ],
                benefits: [
                    'Increased operational efficiency',
                    'Significant cost savings through optimization',
                    'Automated workflows reducing manual work',
                    'Data-driven insights for continuous improvement'
                ]
            }
        },
        whyChooseUs: {
            label: 'Why Us?',
            title: 'Your Trusted IT Partner',
            expertise: {
                title: 'Proven Expertise',
                description: '10+ years of IT experience with successful projects in various industries and ITIL-certified team.'
            },
            solutions: {
                title: 'Innovative Solutions',
                description: 'Modern technologies and proven methods for customized IT solutions that drive your business forward.'
            },
            support: {
                title: 'Reliable Support',
                description: '24/7 technical support with fast response times and proactive maintenance for maximum availability.'
            }
        },
        modal: {
            mainFeatures: 'Main Features',
            benefits: 'Benefits',
            contactUs: 'Contact Us',
            learnMore: 'Learn More'
        },
        cta: {
            title: 'Ready for Digital Transformation?',
            description: 'Contact us for a free consultation and discover how we can support your business.',
            button: 'Contact Now'
        },
        serviceModels: {
            title: 'Special Offer for Our City',
            subtitle: 'Choose the IT maintenance support model that fits your business needs',
            flatRate: {
                title: 'Flat-Rate Basic Health Check Service',
                timeFrame: 'Two hours per month',
                description: 'Our Basic Health Check plan provides proactive monthly maintenance to keep your essential IT systems running smoothly. This service includes:',
                features: [
                    'Maintenance and support for 2 workstation/desk setups',
                    'Operating system diagnostics and issue resolution',
                    'Software and driver status checks and updates',
                    'Network connectivity and performance check',
                    'Security assessment to identify potential threats'
                ],
                conclusion: 'This plan ensures your core devices stay secure, updated, and functioning optimally—all at a predictable monthly cost.',
                contactForPrice: 'For price contact us'
            },
            activityBased: {
                title: 'Activity-Based Customised Service',
                description: 'This model gives you complete control over your IT support. We tailor the service based on your required activities such as:',
                activities: [
                    'Device setup and troubleshooting',
                    'OS, software, and driver updates',
                    'Network diagnostics and optimisation',
                    'Security review and threat clean-up',
                    'Backup or cloud configuration',
                    'User account setup or permissions changes'
                ],
                conclusion: 'Each task is billed individually or grouped into a custom plan—ideal for businesses with changing IT needs.',
                contactForPrice: 'For price contact us'
            }
        },
        items: {
            infrastructure: {
                title: 'On Demand Infrastructure Services',
                description: 'Our comprehensive hardware, network, and data center maintenance services help you unlock the full potential of your IT infrastructure with reliable, scalable solutions.',
                features: [
                    'Hardware Installation & Setup',
                    'Network Infrastructure Management',
                    'Data Center Operations',
                    'System Performance Optimization'
                ],
                benefits: [
                    'Reduced downtime with proactive maintenance',
                    'Scalable infrastructure that grows with your business',
                    'Expert management of complex IT environments',
                    'Cost-effective solutions for infrastructure needs'
                ]
            },
            /*
            helpdesk: {
                title: '24/7 Help Desk Support',
                description: 'Our ITIL-certified helpdesk provides round-the-clock incident management and problem resolution. We prioritize quick resolution times and adhere to strict SLAs to ensure your issues are resolved efficiently.',
                features: [
                    '24/7 Technical Support',
                    'Remote Desktop Assistance',
                    'Quick Issue Resolution',
                    'User Training & Documentation'
                ],
                
                benefits: [
                    'Minimized downtime with fast response times',
                    'ITIL-certified processes for consistent service',
                    'Comprehensive user support and training',
                    'Round-the-clock availability for critical issues'
                ]
            },
            */
            project: {
                title: 'Project Management Support',
                description: 'From planning to execution, our experienced project managers deliver results on time, within scope, and exceeding expectations. We ensure every project is a success story.',
                features: [
                    'Strategic Project Planning',
                    'Software Installation & Configuration',
                    'Change Management',
                    'Quality Assurance & Testing'
                ],
                benefits: [
                    'On-time project delivery within budget',
                    'Expert project management and coordination',
                    'Reduced project risks and improved outcomes',
                    'Seamless implementation with minimal disruption'
                ]
            },
            /*
            development: {
                title: 'Software Development & Testing',
                description: 'Our comprehensive software development and system quality testing services ensure robust, reliable, and optimized solutions. We follow industry best practices for code review, quality assurance, and documentation.',
                features: [
                    'Custom Software Development',
                    'Code Review & Optimization',
                    'Comprehensive Testing',
                    'Technical Documentation'
                ],
                benefits: [
                    'High-quality, maintainable code',
                    'Reduced bugs and improved reliability',
                    'Comprehensive testing for robust solutions',
                    'Well-documented code for future maintenance'
                ]
            },
            */
            optimization: {
                title: 'Process Optimization',
                description: 'Elevate your operations with our systematic approach to process optimization. We identify bottlenecks, implement RPA automation, and leverage data-driven insights to deliver measurable improvements in efficiency and cost savings.',
                features: [
                    'Process Analysis & Mapping',
                    'Efficiency Improvement',
                    'Workflow Automation',
                    'Performance Monitoring'
                ],
                benefits: [
                    'Increased operational efficiency',
                    'Significant cost savings through optimization',
                    'Automated workflows reducing manual work',
                    'Data-driven insights for continuous improvement'
                ]
            },
            data: {
                title: 'Data Management and Analytics',
                description: 'We are experts in the storage, analysis, and management of big data. Our solutions help you leverage advanced analytics for actionable insights and informed decision-making.',
                features: [
                    'Big Data Management',
                    'Advanced Analytics',
                    'Secure Storage Solutions',
                    'Data Governance & Compliance'
                ],
                benefits: [
                    'Actionable insights from your data',
                    'Secure and compliant data management',
                    'Improved decision-making with analytics',
                    'Scalable data solutions for growing needs'
                ]
            },
            dispatch: {
                title: 'Resource or Team as Service',
                description: 'Professional Level 1 & 2 IT support with certified engineers. Our multilingual team provides rapid response times, technical troubleshooting, and personalized solutions for seamless IT operations.',
                features: [
                    'Level 1 & 2 Technical Support',
                    'Multilingual Service Team',
                    'Rapid Response Times',
                    'Certified IT Engineers'
                ],
                benefits: [
                    'Expert technical support when you need it',
                    'Multilingual team for global operations',
                    'Fast response times for critical issues',
                    'Certified professionals ensuring quality service'
                ]
            },
            itsm: {
                title: 'ITSM (IT Service Management)',
                description: 'Comprehensive IT Service Management solutions to streamline your IT operations, improve service delivery, and align IT services with business objectives. We implement industry best practices including ITIL frameworks.',
                features: [
                    'ITIL Framework Implementation',
                    'Service Desk & Incident Management',
                    'Change & Configuration Management',
                    'Service Level Agreement (SLA) Management'
                ],
                benefits: [
                    'Improved IT service quality and consistency',
                    'Better alignment between IT and business goals',
                    'Reduced service disruptions and faster resolution',
                    'Enhanced visibility and control over IT services'
                ]
            },
            itad: {
                title: 'ITAD (IT Asset Disposition)',
                description: 'Secure and environmentally responsible IT asset disposition services. We help you properly retire, recycle, and dispose of IT equipment while ensuring data security and compliance with environmental regulations.',
                features: [
                    'Secure Data Destruction & Wiping',
                    'IT Asset Retirement & Disposal',
                    'Environmental Compliance & Recycling',
                    'Asset Tracking & Documentation'
                ],
                benefits: [
                    'Secure data destruction protecting sensitive information',
                    'Compliance with environmental regulations',
                    'Proper asset lifecycle management',
                    'Cost recovery through asset resale programs'
                ]
            },
            itam: {
                title: 'ITAM (IT Asset Management)',
                description: 'Comprehensive IT Asset Management solutions to track, manage, and optimize your IT assets throughout their entire lifecycle. We help you maintain accurate asset inventories, ensure compliance, and maximize the value of your IT investments.',
                features: [
                    'Asset Discovery & Inventory Management',
                    'Lifecycle Tracking & Maintenance',
                    'License & Compliance Management',
                    'Cost Optimization & Reporting'
                ],
                benefits: [
                    'Complete visibility into your IT asset portfolio',
                    'Reduced costs through optimized asset utilization',
                    'Compliance with software licensing requirements',
                    'Data-driven decisions for IT investments'
                ]
            }
        }
    },
    about: {
        title: 'About Us',
        subtitle: 'A Trusted Technology Partner',
        hero: {
            titlePart1: 'About',
            titlePart2: 'Heidelbell',
            subtitle: 'Your trusted IT partner for innovative solutions'
        },
        description: 'Heidelbell is a dynamic, technology-oriented consulting and services company based in Heidelberg, Germany. We specialize in helping organizations achieve operational excellence through our simple and proved 3Es approach: Evaluate, Execute, and Elevate. Our ITIL-certified team provides comprehensive IT support, process optimization, and digital transformation services.',
        companyStory: {
            label: 'Our Story',
            title: 'From Heidelberg to the World',
            paragraph1: 'Since 2022, we have been your trusted partner for digital transformation. Our mission: to help companies achieve sustainable success with innovative IT solutions.',
            paragraph2: 'With our ITIL-certified team, we offer customized solutions for businesses of all sizes. Our focus: reliability, innovation, and measurable results.'
        },
        milestones: [
            {
                year: '2022',
                description: 'Foundation of Heidelbell in Heidelberg with focus on IT support and consulting'
            },
            {
                year: '2023',
                description: 'Expansion of service portfolio to include cloud solutions and cybersecurity'
            },
            {
                year: '2024',
                description: 'Opening of new locations and expansion of the team'
            }
        ],
        values: {
            label: 'Our Values',
            title: 'What Drives Us',
            items: [
                {
                    title: 'Innovation',
                    description: 'Modern technologies and future-oriented solutions for sustainable success.'
                },
                {
                    title: 'Reliability',
                    description: '24/7 support with fast response times and proactive maintenance.'
                },
                {
                    title: 'Partnership',
                    description: 'Long-term cooperation with measurable results and continuous improvement.'
                }
            ]
        },
        team: {
            label: 'Our Team',
            title: 'The Experts Behind Heidelbell',
            members: [
                {
                    name: 'Dr. Naved Chaudhri',
                    position: 'Managing Director',
                    bio: '15+ years of experience in IT and medical technologies, specialist for digital transformation and strategic IT consulting.',
                    linkedin: 'https://www.linkedin.com/in/naved-c-a2a920b6'
                }
            ],
            poolImage: {
                title: 'Our Tech Network',
                description: 'A network of engineers and technicians across Germany, ready to support your business wherever you are.'
            }
        },
        cta: {
            title: 'Ready to Collaborate?',
            description: 'Let\'s work together to solve your IT challenges and digitally transform your business.',
            button: 'Get in Touch'
        },
        method: {
            title: 'Our Proven Simple 3Es Approach',
            evaluate: 'We meticulously evaluate your current situation to identify bottlenecks, inefficiencies, and opportunities for improvement',
            execute: 'We execute strategic plans with precision and expertise, ensuring seamless implementation and minimal disruption',
            elevate: 'We elevate your business to new heights of success and efficiency through sustainable, measurable improvements'
        },
        stats: {
            experience: 'Years of Experience',
            clients: 'Happy Clients',
            projects: 'Completed Projects',
            support: '24/7 Support'
        },
        achievement: {
            number: '10+',
            label: 'Years of Expertise'
        },
        whyChooseTitle: 'Why Choose Heidelbell',
        whyChoosePoints: [
            'ITIL-certified team with proven industry practices',
            'Multilingual support with cultural understanding',
            'Proven 3Es approach for guaranteed results',
            'Comprehensive End-to-End IT solutions',
            '24/7 Support with fast response times',
            'Customized solutions for your business'
        ]
    },

    gallery: {
        title: 'Our Work',
        subtitle: 'Project Gallery',
        hero: {
            title: 'Our Work',
            subtitle: 'Project Gallery'
        },
        viewDetails: 'View Details'
    },
    portfolio: {
        comingSoon: {
            title: 'Coming Soon',
            message: 'Our portfolio is currently under construction. Check back soon to see our amazing projects and case studies!',
            close: 'Close'
        }
    },
    brands: {
        label: 'Our Partners',
        title: 'Trusted IT Brands We Work With',
        description: 'Our expertise and experience with leading technology providers to deliver the best solutions for your business',
        items: [
            { name: 'Microsoft', icon: 'MS' },
            { name: 'AWS', icon: 'AWS' },
            { name: 'Cisco', icon: 'CS' },
            { name: 'VMware', icon: 'VM' },
            { name: 'Oracle', icon: 'OR' },
            { name: 'IBM', icon: 'IBM' },
            { name: 'Dell', icon: 'DL' },
            { name: 'HP', icon: 'HP' },
            { name: 'Red Hat', icon: 'RH' },
            { name: 'SAP', icon: 'SAP' },
            { name: 'Salesforce', icon: 'SF' },
            { name: 'Google Cloud', icon: 'GC' }
        ]
    },
    contact: {
        //title: 'Ready to Transform Your Business?',
        title: 'The solution lies in focused listening, which we we can do.',
        subtitle: 'Let\'s discuss how we can help you achieve the IT leveraged operational excellence',
        hero: {
            titlePart1: 'Focused Listening.',
            titlePart2: 'Better Solutions',
            subtitle: 'Through concentrated listening, we turn your concerns into solutions.'
        },
        form: {
            title: 'Send Us a Message',
            firstName: 'First Name',
            lastName: 'Last Name',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            service: 'Service Type',
            serviceType: 'What type of services',
            selectService: 'Select a service',
            subject: 'Subject',
            message: 'Message',
            submit: 'Send Message',
            submitting: 'Sending...',
            success: 'Your message has been sent successfully. We will get back to you shortly.'
        },
        validation: {
            nameRequired: 'Name is required.',
            emailRequired: 'Email is required.',
            emailInvalid: 'Please enter a valid email address.',
            subjectRequired: 'Subject is required.',
            messageRequired: 'Message is required.'
        },
        info: {
            title: 'Contact Information',
            description: 'Our team is available for all your questions. We respond within 24 hours.',
            address: {
                label: 'Address',
                value: 'Jahnstrasse 32, 69120 Heidelberg, Germany'
            },
            officeAddress: {
                label: 'Office Address',
                value: 'Ringstr. 19B, 69115 Heidelberg, Germany'
            },
            phone: {
                label: 'Phone',
                value: '+49 (0) 6221 6470309'
            },
            email: {
                label: 'Email',
                value: 'connect@heidelbell.com'
            },
            location: {
                label: 'Location',
                value: 'Heidelberg, Germany'
            },
            whatsapp: {
                label: 'WhatsApp',
                value: '+49 176 47050093'
            },
            addressValue: 'Ringstr. 19B, 69115 Heidelberg, Germany',
            emailValue: 'connect@heidelbell.com',
            phoneValue: '+49 (0) 6221 6470309',
            whatsappValue: '+49 176 47050093'
        },
        businessHours: {
            title: 'Business Hours',
            days: [
                { name: 'Monday - Friday', hours: '09:00 - 18:00' },
                { name: 'Saturday', hours: 'Closed' },
                { name: 'Sunday', hours: 'Closed' }
            ]
        },
        whyChoose: {
            title: 'Why Choose Us',
            points: {                
                customized: 'Customized Solutions',
                support: '24/7 Support',
                secure: 'Secure Solutions',
                fast: 'Fast Response',
                approach: 'Proven 3Es Approach'
            },
            approach: {
                title: 'Our Proven Simple 3Es Approach',
                evaluate: 'We meticulously evaluate your current situation to identify bottlenecks, inefficiencies, and opportunities for improvement',
                execute: 'We execute strategic plans with precision and expertise, ensuring seamless implementation and minimal disruption',
                elevate: 'We elevate your business to new heights of success and efficiency through sustainable, measurable improvements'
            }
        }
    },
    footer: {
        copyright: '© 2025 Heidelbell',
        links: {
            privacy: 'Data Security',
            terms: 'Terms & Conditions',
            imprint: 'Imprint',
            attributions: 'Attributions'
        },
        bottom: 'All rights reserved by Heidelbell GmbH , Made with ❤️ by Heidelbell'
    },
    // SEO
    seo: {
        home: {
            title: 'IT Service Provider Heidelberg | Experienced IT Services & Best Solutions - Heidelbell',
            description: 'Heidelbell is an experienced IT Service Provider in Heidelberg, Germany, offering the best IT solutions and services. With proven expertise in IT Service Management (ITSM), IT Infrastructure, and 24/7 IT Support, we deliver professional IT services that drive business success. Trust our experienced team for reliable IT solutions.',
            keywords: 'IT Service Provider, IT Service Provider Heidelberg, IT Dienstleister, IT Dienstleister Heidelberg, experienced IT Service Provider, best IT solutions, IT Services Heidelberg, IT Services in Heidelberg, Heidelberg IT services, ITSM, IT Service Management, ITAD, IT Asset Disposition, ITAM, IT Asset Management, Smart Hands, IT Support, IT Infrastructure, Technology Consulting, Heidelberg, Germany, Professional IT Services, Best IT Solutions, Experienced IT Provider, Customized Solutions, 24/7 Support, Secure Solutions, Fast Response, Windows, Linux, macOS, Server, Network, Security, Backup, Disaster Recovery, Cloud, Virtualization, Automation, Monitoring, Reporting, ITIL, IT Operations Management, IT Infrastructure Management, IT Service Delivery, IT Service Support, IT Service Operation, Remote Hands, On-site Support, IT Consulting, Cloud Solutions, Infrastructure Services, Network Support, Server Management, Data Center Services, Help Desk, Technical Support, IT Maintenance, Managed IT Services'
        },
        about: {
            title: 'About Us - Heidelbell | Technology Consulting & 3Es Approach',
            description: 'Learn about Heidelbell\'s proven 3Es (Evaluate, Execute, Elevate) approach and how we help organizations unlock their potential through technology consulting.',
            keywords: 'About Heidelbell, 3Es Approach, Technology Consulting, Heidelberg, Germany, IT Services, Business Transformation'
        },
        services: {
            title: 'IT Services - Heidelbell | Infrastructure, Development & Support',
            description: 'Comprehensive IT services including infrastructure installation, help desk support, software development, process optimization, and data management.',
            keywords: 'ITSM, IT Service Management, ITAD, IT Asset Disposition, ITAM, IT Asset Management, Smart Hands, IT Services, Infrastructure Installation, Help Desk Support, Software Development, Process Optimization, Data Management, IT Consulting, ITIL, Remote Hands, On-site Support, IT Operations, IT Service Delivery, Technical Support, IT Maintenance, Cloud Solutions, Network Support, Server Management'
        },
        contact: {
            title: 'Contact Us - Heidelbell | Get in Touch for IT Solutions',
            description: 'Contact Heidelbell for IT infrastructure and technology consulting services. Located in Heidelberg, Germany. Get expert advice and support.',
            keywords: 'Contact Heidelbell, IT Consulting Heidelberg, Technology Support, IT Infrastructure Services, Heidelberg IT Company, ITSM Services, ITAD Services, ITAM Services, Smart Hands Support'
        }
    },
    // Privacy Policy
    privacy: {
        title: 'Privacy Policy',
        subtitle: 'Data Protection and Privacy Information',
        lastUpdated: 'Last Updated',
        seo: {
            title: 'Privacy Policy - Heidelbell | Data Protection',
            description: 'Learn about how Heidelbell protects your personal data and privacy in accordance with GDPR regulations.'
        },
        introduction: {
            title: 'Introduction',
            content: 'Heidelbell is committed to protecting your privacy and ensuring the security of your personal data. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or use our services.',
            contact: 'If you have any questions about this Privacy Policy, please contact us using the information provided below.'
        },
        controller: {
            title: 'Data Controller',
            name: 'Company Name',
            address: 'Address',
            email: 'Email',
            phone: 'Phone'
        },
        collection: {
            title: 'Data Collection',
            intro: 'We collect information that you provide directly to us through our contact form, as well as limited data stored locally in your browser.',
            personal: {
                title: 'Personal Information You Provide',
                name: 'Name (via contact form)',
                email: 'Email address (via contact form)',
                subject: 'Subject and service type (via contact form)',
                message: 'Messages and inquiries (via contact form)'
            },
            automatic: {
                title: 'Locally Stored Data',
                locale: 'Language preference (stored in your browser\'s localStorage)',
                consent: 'Cookie consent preference (stored in your browser\'s localStorage)',
                recaptcha: 'Google reCAPTCHA v3 is used on the contact form for spam protection. This may send your IP address and browser data to Google. For details, see Google\'s Privacy Policy.'
            }
        },
        purpose: {
            title: 'Purpose of Data Processing',
            intro: 'We use your personal data for the following purposes:',
            communication: 'To communicate with you and respond to your inquiries submitted through our contact form',
            services: 'To provide our IT services and support',
            website: 'To remember your language preference for a better user experience',
            legal: 'To comply with legal obligations',
            spam: 'To protect our contact form from spam and abuse (via Google reCAPTCHA)'
        },
        legalBasis: {
            title: 'Legal Basis for Processing',
            intro: 'We process your personal data based on the following legal grounds:',
            consent: {
                title: 'Consent',
                content: 'When you explicitly agree to the processing of your personal data for specific purposes.'
            },
            contract: {
                title: 'Contract Performance',
                content: 'When processing is necessary to fulfill our contractual obligations to you.'
            },
            legitimate: {
                title: 'Legitimate Interest',
                content: 'When processing is necessary for our legitimate business interests, provided these do not override your fundamental rights.'
            }
        },
        retention: {
            title: 'Data Retention',
            intro: 'We retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy:',
            contact: 'Contact form submissions: Retained as long as necessary to respond to your inquiry',
            localStorage: 'Browser localStorage data (language preference, cookie consent): Stored locally in your browser until you clear your browser data',
            legal: 'Legal requirements: As required by law'
        },
        rights: {
            title: 'Your Rights',
            intro: 'Under GDPR, you have the following rights regarding your personal data:',
            access: {
                title: 'Right of Access',
                content: 'You can request a copy of the personal data we hold about you.'
            },
            rectification: {
                title: 'Right of Rectification',
                content: 'You can request correction of inaccurate or incomplete personal data.'
            },
            erasure: {
                title: 'Right of Erasure',
                content: 'You can request deletion of your personal data in certain circumstances.'
            },
            portability: {
                title: 'Right of Portability',
                content: 'You can request transfer of your personal data to another service provider.'
            }
        },
        contact: {
            title: 'Contact Information',
            intro: 'If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us:',
            email: 'Email',
            phone: 'Phone',
            address: 'Address'
        },
        changes: {
            title: 'Changes to This Privacy Policy',
            content: 'This Privacy Policy may be updated periodically to reflect changes in our practices or legal requirements. Any updates will be published on this page. Please review this page regularly to stay informed.'
        }
    },
    // Terms & Conditions
    terms: {
        title: 'Terms & Conditions',
        subtitle: 'Terms of Service and Business Conditions',
        lastUpdated: 'Last Updated',
        seo: {
            title: 'Terms & Conditions - Heidelbell | Service Terms',
            description: 'Read Heidelbell\'s terms and conditions for IT services, including our 3Es approach and service commitments.'
        },
        introduction: {
            title: 'Introduction',
            content: 'These Terms and Conditions govern the use of Heidelbell\'s services and website. By using our services, you agree to be bound by these terms.',
            acceptance: 'Your continued use of our services constitutes acceptance of these terms.'
        },
        company: {
            title: 'Company Information',
            name: 'Company Name',
            address: 'Address',
            email: 'Email',
            phone: 'Phone'
        },
        services: {
            title: 'Services',
            intro: 'Heidelbell provides comprehensive IT consulting and services using our proven 3Es (Evaluate, Execute, Elevate) approach.',
            offered: {
                title: 'Services Offered',
                infrastructure: 'Infrastructure Installation & Maintenance',
                helpdesk: 'Help Desk Support',
                project: 'Project Management Support',
                development: 'Software Development & Testing',
                optimization: 'Process Optimization',
                data: 'Data Management'
            },
            quality: {
                title: 'Service Quality',
                content: 'We are committed to providing high-quality services that meet industry standards and exceed client expectations.'
            }
        },
        client: {
            title: 'Client Obligations',
            intro: 'As a client, you agree to:',
            cooperation: 'Provide necessary cooperation and access to systems',
            information: 'Supply accurate and complete information',
            access: 'Grant reasonable access to your premises and systems',
            payment: 'Pay invoices in accordance with payment terms',
            confidentiality: 'Maintain confidentiality of our proprietary information'
        },
        payment: {
            title: 'Payment Terms',
            invoicing: {
                title: 'Invoicing',
                content: 'Invoices will be issued monthly or upon completion of services, as agreed in individual service agreements.'
            },
            terms: {
                title: 'Payment Terms',
                content: 'Payment is due within 30 days of invoice date unless otherwise specified in the service agreement.'
            },
            late: {
                title: 'Late Payment',
                content: 'Late payments may result in suspension of services and additional charges as permitted by law.'
            }
        },
        intellectual: {
            title: 'Intellectual Property',
            heidelbell: {
                title: 'Heidelbell IP',
                content: 'All intellectual property developed by Heidelbell remains our property unless explicitly transferred in writing.'
            },
            client: {
                title: 'Client IP',
                content: 'Client intellectual property remains the property of the client. We respect and protect client IP rights.'
            },
            third: {
                title: 'Third-Party IP',
                content: 'We ensure proper licensing and compliance with third-party intellectual property used in our services.'
            }
        },
        confidentiality: {
            title: 'Confidentiality',
            intro: 'Both parties agree to maintain strict confidentiality of proprietary and sensitive information.',
            obligation: {
                title: 'Confidentiality Obligation',
                content: 'All information shared during our engagement is treated as confidential and protected accordingly.'
            },
            exceptions: {
                title: 'Exceptions',
                public: 'Information that is publicly available',
                legal: 'Information required by law or court order',
                consent: 'Information disclosed with written consent'
            }
        },
        liability: {
            title: 'Liability',
            limitation: {
                title: 'Limitation of Liability',
                content: 'Our liability is limited to the amount paid for the specific service giving rise to the claim.'
            },
            exclusions: {
                title: 'Excluded Damages',
                indirect: 'Indirect or consequential damages',
                consequential: 'Loss of profits or business interruption',
                third: 'Third-party claims'
            },
            maximum: {
                title: 'Maximum Liability',
                content: 'Our total liability shall not exceed the total amount paid by the client in the 12 months preceding the claim.'
            }
        },
        termination: {
            title: 'Termination',
            notice: {
                title: 'Notice Period',
                content: 'Either party may terminate services with 30 days written notice, unless otherwise specified in the service agreement.'
            },
            immediate: {
                title: 'Immediate Termination',
                breach: 'Material breach of these terms',
                insolvency: 'Insolvency or bankruptcy',
                force: 'Force majeure events'
            },
            effects: {
                title: 'Effects of Termination',
                content: 'Upon termination, we will complete work in progress and return client property. Payment for completed services remains due.'
            }
        },
        forceMajeure: {
            title: 'Force Majeure',
            content: 'Neither party shall be liable for delays or failures due to circumstances beyond reasonable control, including natural disasters, government actions, or technical failures.'
        },
        governing: {
            title: 'Governing Law',
            content: 'These terms are governed by German law. Any disputes shall be resolved in the courts of Heidelberg, Germany.'
        },
        disputes: {
            title: 'Dispute Resolution',
            content: 'We encourage amicable resolution of disputes. If necessary, disputes will be resolved through mediation or legal proceedings in Heidelberg, Germany.'
        },
        severability: {
            title: 'Severability',
            content: 'If any provision of these terms is found to be unenforceable, the remaining provisions shall continue in full force and effect.'
        },
        contact: {
            title: 'Contact Information',
            intro: 'For questions about these terms, please contact us:',
            email: 'Email',
            phone: 'Phone',
            address: 'Address'
        }
    },
    // Impressum
    imprint: {
        title: 'Imprint',
        subtitle: 'Legal Information and Company Details',
        lastUpdated: 'Last Updated',
        seo: {
            title: 'Imprint - Heidelbell | Legal Information',
            description: 'Legal information and company details for Heidelbell, including contact information and legal representatives.'
        },
        provider: {
            title: 'Service Provider Information',
            name: 'Company Name',
            address: 'Street Address',
            city: 'City and Postal Code',
            country: 'Country'
        },
        contact: {
            title: 'Contact Information',
            email: 'Email',
            phone: 'Phone',
            website: 'Website'
        },
        representatives: {
            title: 'Legal Representatives',
            content: 'The legal representatives of Heidelbell are responsible for the content of this website in accordance with German law.'
        },
        register: {
            title: 'Commercial Register',
            court: 'Registration Court',
            courtValue: 'Registry Court Mannheim',
            number: 'Registration Number',
            numberValue: 'HRB 747244'
        },
        vat: {
            title: 'VAT Information',
            content: 'VAT identification number: DE359108048'
        },
        professional: {
            title: 'Professional Associations',
            content: 'Heidelbell maintains membership in relevant professional associations and adheres to industry standards and best practices.'
        },
        responsibility: {
            title: 'Content Responsibility',
            content: 'The content of this website is carefully maintained and updated. However, we cannot guarantee the accuracy, completeness, or timeliness of all information.'
        },
        copyright: {
            title: 'Copyright',
            content: 'All content on this website, including text, images, and design, is protected by copyright and belongs to Heidelbell unless otherwise stated.'
        },
        links: {
            title: 'External Links',
            content: 'This website may contain links to external websites. We are not responsible for the content of external websites and disclaim any liability for their content.'
        },
        disclaimer: {
            title: 'Disclaimer',
            content: 'The information provided on this website is for general informational purposes only. We make no warranties about the accuracy or completeness of the information.',
            contentLiability: {
                title: 'Content Liability',
                content: 'The contents of our pages were created with the greatest care. However, we cannot guarantee the accuracy, completeness, or timeliness of the content. As a service provider, we are responsible for our own content on these pages under general law in accordance with § 7 para.1 TMG. According to §§ 8 to 10 TMG, however, we as a service provider are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general law remain unaffected. However, liability in this regard is only possible from the time of knowledge of a specific infringement. Upon becoming aware of corresponding legal violations, we will remove this content immediately.'
            },
            linkLiability: {
                title: 'Link Liability',
                content: 'Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the linked pages is always responsible for their content. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking. However, permanent content monitoring of the linked pages is not reasonable without concrete indications of a legal violation. Upon becoming aware of legal violations, we will remove such links immediately.'
            }
        },
        dataProtection: {
            title: 'Data Protection',
            content: 'Information about how we handle your personal data can be found in our Privacy Policy.',
            link: 'Privacy Policy'
        },
        generatorNote: {
            content: 'Imprint supported by the Imprint Generator of Kanzlei Hasselbach, Frankfurt.'
        },
        technical: {
            title: 'Technical Information',
            hosting: 'Web Hosting',
            hostingValue: 'Cloud-based hosting service',
            framework: 'Frontend Framework',
            styling: 'CSS Framework',
            build: 'Build Tool'
        }
    },
    // Cookie Consent
    cookies: {
        title: 'Cookie Consent',
        message: 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept", you consent to our use of cookies.',
        accept: 'Accept',
        reject: 'Reject',
        learnMore: 'Learn more about our cookie policy'
    },
    // Attributions & Credits
    attributions: {
        title: 'Attributions & Credits',
        subtitle: 'Image and Media Credits',
        lastUpdated: 'Last Updated',
        seo: {
            title: 'Attributions & Credits - Heidelbell | Image Credits',
            description: 'Credits and attributions for images, videos, and graphics used on the Heidelbell website, including Freepik assets.'
        },
        introduction: {
            title: 'Introduction',
            content: 'We believe in giving proper credit to the creators whose work enhances our website. This page lists all third-party images, videos, and graphics used on our site, along with their sources and attribution information.'
        },
        disclaimer: {
            title: 'General Disclaimer',
            content: 'While we strive to ensure accuracy in all attributions and credits listed on this page, we acknowledge that errors may occur. This disclaimer covers:',
            typos: 'Typographical errors, misspellings, or formatting mistakes in attribution information',
            accuracy: 'Inaccuracies in URLs, author names, or other attribution details that may have occurred during data entry or updates',
            contact: 'If you notice any errors or inaccuracies, please contact us so we can correct them promptly'
        },
        freepik: {
            title: 'Freepik Assets',
            intro: 'Some images, videos, and vector graphics used on this website are from Freepik.com. We are grateful to the creators who make their work available through Freepik.',
            disclaimer: 'Freepik License:',
            license: 'All assets used from Freepik are subject to Freepik\'s licensing terms. For premium assets, we have obtained the appropriate licenses. For free assets, we comply with Freepik\'s attribution requirements.',
            by: 'by',
            images: {
                title: 'Images from Freepik'
            },
            videos: {
                title: 'Videos from Freepik'
            },
            vectors: {
                title: 'Vector Graphics & Icons from Freepik'
            },
            
            template: {
                title: 'How to Add Attribution Links',
                instruction: 'To add your Freepik attribution links, edit the freepikAssets object in src/views/Attributions.vue and add entries in the following format:'
            }
        },
        
        other: {
            title: 'Other Attributions',
            intro: 'Additional assets and resources used on this website:',
            none: 'No other third-party assets are currently used.',
            
        },
    
        contact: {
            title: 'Contact',
            intro: 'If you have questions about attributions or believe an asset has been incorrectly attributed, please contact us:',
            email: 'Email',
            phone: 'Phone'
        }
    }
} 